import api from '../utils/api';
import { DashboardV4Data, JunoDashboardContext } from '../types/dashboard-v4.types';

export interface DashboardServiceResponse {
  data: DashboardV4Data;
  junoContext: JunoDashboardContext;
}

class DashboardV4Service {
  async fetchDashboardData(): Promise<DashboardServiceResponse> {
    try {
      // Fetch dashboard data from dedicated endpoint
      const response = await api.getApi().get('/v1/dashboard/today');
      
      // Backend returns data in the exact format we need
      const dashboardData: DashboardV4Data = {
        user: response.data.user,
        whatsChanged: response.data.whatsChanged,
        whatNeedsAttention: response.data.whatNeedsAttention.map((item: any) => ({
          ...item,
          // Map backend actionPath to frontend route
          actionPath: `/v3/vault/${item.signalId}`
        })),
        totalOpenSignals: response.data.totalOpenSignals,
        totalOpenCases: response.data.totalOpenCases,
        averageConductScore: response.data.averageConductScore ?? (response.data.averageSeverityScore != null ? response.data.averageSeverityScore / 10 : 0),
        averageStrainScore: response.data.averageStrainScore,
        averageHarmScore: response.data.averageHarmScore,
        signalsAndCasesOverTime: response.data.signalsOverTime,
        complaintDetection: response.data.complaintDetection,
        channelBreakdown: response.data.channelBreakdown,
        vulnerabilityDetection: response.data.vulnerabilityDetection,
        openCasesByAge: response.data.openCasesByAge,
        topRootCauses: response.data.topRootCauses
      };
      
      return {
        data: dashboardData,
        junoContext: response.data.junoContext
      };
      
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      throw error;
    }
  }
}

export const dashboardV4Service = new DashboardV4Service();